<div class="content-info">
  <div class="content-title">
    <h3 class="title">Purchase Return Notes</h3>
    <div class="title-actions">
      <label class="zf-search" title="Search by PRN number">
        <i class="bi bi-search"></i>
        <input type="text" (input)="onSearch()" placeholder="Search PRN number" />
      </label>
      <button class="btn btnprimary text-nowrap" [routerLink]="['/prn/create']">
        <i class="bi bi-plus-lg"></i>Create PRN
      </button>
    </div>
  </div>

  <div class="common-table mt-2">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>PRN Number</th>
            <th>Vendor</th>
            <th>Return Date</th>
            <th class="zf-num">Total Items</th>
            <th class="zf-num">Total Units</th>
            <th class="zf-num">Amount (INR)</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if(prnsLoading) {
          <tr>
            <td colspan="8" class="text-center">Loading purchase returns…</td>
          </tr>
          } @else { @if(!prnList.length) {
          <tr>
            <td colspan="8">
              <div class="zf-empty">
                <strong>No purchase return notes yet</strong>
                <span>Create a PRN to return goods to a vendor.</span>
              </div>
            </td>
          </tr>
          } @else { @for(prn of prnList; track prn.id) {
          <tr>
            <td class="zf-key">
              <a [routerLink]="['/prn/edit', prn.id]" [queryParams]="{ view: true }">{{ prn.prnNumber }}</a>
            </td>
            <td>{{ prn.vendor?.name || '-' }}</td>
            <td class="zf-mono">{{ prn.returnDate | date : "dd-MM-yy" }}</td>
            <td class="zf-num">{{ prn.totalItems || 0 }}</td>
            <td class="zf-num zf-dim">{{ prn.totalQty || 0 }}</td>
            <td class="zf-num zf-strong">{{ prn.totalAmount || 0 | number : '1.2-2' }}</td>
            <td>
              <!-- POSTED = stock debited, goods staged awaiting vendor pickup;
                   DISPATCHED = physically handed over (terminal). -->
              <span class="zf-status" [ngClass]="{
                  ok: prn.status === 'DISPATCHED',
                  primary: prn.status === 'POSTED',
                  warn: prn.status !== 'DISPATCHED' && prn.status !== 'POSTED' && prn.status !== 'CANCELLED'
                }" [title]="
                  prn.status === 'POSTED'
                    ? 'Stock debited — goods awaiting handover to vendor'
                    : prn.status === 'DISPATCHED'
                    ? 'Handed over to vendor'
                    : ''
                ">
                {{ prn.status === 'DISPATCHED' ? 'HANDED OVER' : prn.status }}
              </span>
            </td>
            <td>
              <div class="td-actions-btn">
                @if (prn.status === 'DRAFT') {
                <button class="btn btn-edit" [routerLink]="['/prn/edit', prn.id]" title="Edit draft">
                  <i class="bi bi-pencil-square"></i>
                </button>
                }
                @if (prn.status === 'POSTED') {
                <button class="btn btn-handover" (click)="markHandedOver(prn)" [disabled]="dispatching.has(prn.id)"
                  title="Mark goods as handed over to the vendor">
                  @if (dispatching.has(prn.id)) {
                  <span class="spinner-border spinner-border-sm"></span>
                  } @else {
                  <i class="bi bi-truck"></i>
                  }
                </button>
                }
                <button class="btn btn-download" (click)="downloadPrn(prn.id)" title="Download PDF">
                  <i class="bi bi-file-earmark-pdf"></i>
                </button>
              </div>
            </td>
          </tr>
          } } }
        </tbody>
      </table>
    </div>

    <app-pagination [page]="currentPage" [limit]="pageSize" [pageCount]="pageCount" (pageChange)="goToPage($event)"
      (limitChange)="onPageSizeChange($event)">
    </app-pagination>
  </div>
</div>
